import { __decorate } from "tslib";
import { Component, ViewEncapsulation, Input } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { DomSanitizer } from '@angular/platform-browser';
let PaymentInstructionsComponent = class PaymentInstructionsComponent {
    constructor(httpClient, webSettingsService, domSanitizer) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.domSanitizer = domSanitizer;
        this.objectKeys = Object.keys;
        this.isCompanyUser = (JSON.parse(localStorage.getItem('user')).hasOwnProperty('is_company_user')) ? JSON.parse(localStorage.getItem('user')).is_company_user : false;
    }
    ngOnInit() {
        if (this.orderId) {
            this.httpClient.post('market/order/getpaymentslip', {
                order_id: this.orderId
            }).subscribe((result) => {
                this.response = result;
                this.response['PAYMENT_SLIP.TOTAL'] = (typeof this.response['PAYMENT_SLIP.TOTAL'] !== 'undefined') ?
                    (Math.round(parseFloat(this.response['PAYMENT_SLIP.TOTAL'] + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') :
                    '';
                this.response['order_amount'] = (typeof this.response['order_amount'] !== 'undefined') ?
                    (parseFloat(this.response['order_amount'] + '')).toString().replace('.', ',') : '';
                this.b64ImgUrl = (typeof this.response['ips_qr'] !== 'undefined' && this.response['ips_qr'] !== null && this.response['ips_qr'].b64data !== null) ?
                    this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.response['ips_qr'].b64data) : '';
            });
        }
        else if (this.paymentData) {
            this.shopResponse = this.paymentData;
            this.b64ImgUrl = (typeof this.shopResponse['ips_qr'] !== 'undefined' && this.shopResponse['ips_qr'] !== null && this.shopResponse['ips_qr'].b64data !== null) ?
                this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.shopResponse['ips_qr'].b64data) : '';
            this.shopResponse.total_in_crypto = (typeof this.shopResponse.total_in_crypto !== 'undefined') ?
                (parseFloat(this.shopResponse.total_in_crypto + '')).toString().replace('.', ',') : '';
            this.shopResponse['PAYMENT_SLIP.TOTAL'] = (typeof this.shopResponse['PAYMENT_SLIP.TOTAL'] !== 'undefined') ?
                (Math.round(parseFloat(this.shopResponse['PAYMENT_SLIP.TOTAL'] + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') :
                '';
        }
    }
    checkIfNotObject(key) {
        return (typeof key !== 'object' && typeof key !== 'undefined');
    }
};
PaymentInstructionsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer }
];
__decorate([
    Input()
], PaymentInstructionsComponent.prototype, "orderId", void 0);
__decorate([
    Input()
], PaymentInstructionsComponent.prototype, "paymentData", void 0);
PaymentInstructionsComponent = __decorate([
    Component({
        selector: 'ecd-payment-instructions',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./payment-instructions.component.html")).default
    })
], PaymentInstructionsComponent);
export { PaymentInstructionsComponent };
